<cc-top-bar [title]="('FIRST_STEPS.ROOT_HEADER' | translate)"></cc-top-bar>
<section class="route-wrapper">
  <router-outlet></router-outlet>
</section>
